import { render, staticRenderFns } from "./PostViewSelectionVo.vue?vue&type=template&id=37d8519e&"
import script from "./PostViewSelectionVo.vue?vue&type=script&lang=js&"
export * from "./PostViewSelectionVo.vue?vue&type=script&lang=js&"
import style0 from "./PostViewSelectionVo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports